(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sen-card-swatches"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const swatch = event.target.closest('[data-sen-card-swatch]');
    if (!swatch) return;

    const card = swatch.closest('.sen-shop-card, .card-wrapper, .beae-product-card');
    if (!card) return;

    event.preventDefault();
    event.stopPropagation();

    const group = swatch.closest('.sen-card-swatches');
    group?.querySelectorAll('[data-sen-card-swatch]').forEach((choice) => {
      const selected = choice === swatch;
      choice.classList.toggle('is-selected', selected);
      if (selected) choice.setAttribute('aria-current', 'true');
      else choice.removeAttribute('aria-current');
    });

    const image = card.querySelector('.sen-shop-card__image, .card__media img, .beae-image-primary img');
    const imageUrl = swatch.dataset.senCardImage;
    if (image && imageUrl) {
      image.removeAttribute('srcset');
      image.src = imageUrl;
      image.alt = swatch.getAttribute('aria-label') || image.alt;

      // Dawn and Beae can reveal a second image on hover; keep the chosen color visible.
      const secondary = card.querySelector('.card__media img:nth-child(2), .beae-image-secondary img');
      if (secondary) {
        secondary.removeAttribute('srcset');
        secondary.src = imageUrl;
        secondary.alt = image.alt;
      }
    }

    card.querySelectorAll('.sen-shop-card__media > a, .sen-shop-card__title a, .card__heading a, .beae-image-product, .beae-product-title a').forEach((link) => {
      link.href = swatch.href;
    });
  }, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sen-mega-menu-groups"] && !Shopify.designMode) return;
  try {
    document.addEventListener('shopify:block:select', (event) => {
    if (!event.detail?.blockId) return;
    const desktop = window.matchMedia('(min-width: 990px)').matches;
    const scope = desktop ? '.header__inline-menu' : '.menu-drawer';
    const group = document.querySelector(`${scope} [data-sen-menu-group="${CSS.escape(event.detail.blockId)}"]`);
    if (!group) return;
    const ancestors = [];
    for (let node = group.parentElement; node; node = node.parentElement) {
      if (node.tagName === 'DETAILS') ancestors.unshift(node);
    }
    ancestors.forEach((details) => {
      if (!details.open) details.querySelector(':scope > summary')?.click();
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sen-product-ui"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('sen-product-ui')) return;
    const wishlistKey = 'the-sen:wishlist:v1';
    const recentKey = 'the-sen:recent-products:v1';
    const validHandle = (value) => typeof value === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(value);
    const read = (key) => {
      try {
        const values = JSON.parse(localStorage.getItem(key) || '[]');
        return Array.isArray(values) ? [...new Set(values.filter(validHandle))].slice(0,50) : [];
      } catch { return []; }
    };
    let saved = read(wishlistKey);
    const write = (key, values) => { try { localStorage.setItem(key, JSON.stringify(values)); } catch {} };
    const sync = () => document.querySelectorAll('[data-sen-wishlist]').forEach(button => button.setAttribute('aria-pressed', String(saved.includes(button.dataset.senWishlist))));
    const tileCache = new Map();
    const getTile = async (handle) => {
      if (!validHandle(handle)) return null;
      const root = window.Shopify?.routes?.root || '/';
      const url = new URL(`${root}products/${encodeURIComponent(handle)}`, location.origin);
      url.searchParams.set('section_id','sen-product-tile');
      if (!tileCache.has(url.href)) tileCache.set(url.href, fetch(url.href).then(response => {
        if (!response.ok) throw new Error('Product unavailable');
        return response.text();
      }).then(html => new DOMParser().parseFromString(html,'text/html').querySelector('.sen-shop-card')).catch(() => { tileCache.delete(url.href); return null; }));
      const tile = await tileCache.get(url.href);
      return tile?.cloneNode(true) || null;
    };
    customElements.define('sen-wishlist-toggle',class extends HTMLElement { connectedCallback() { sync(); } });
    customElements.define('sen-product-shelf',class extends HTMLElement {
      async connectedCallback() {
        const handles = read(recentKey).slice(0,6);
        const cards = await Promise.all(handles.map(getTile));
        const target = this.querySelector('[data-sen-shelf-items]');
        if (!target || !this.isConnected) return;
        const visibleCards = cards.filter(Boolean);
        visibleCards.forEach((card,index) => { card.id = `Slide-${target.id}-${index}`; });
        target.replaceChildren(...visibleCards);
        this.hidden = !target.children.length;
        this.querySelector('slider-component')?.resetPages?.();
        sync();
      }
    });
    customElements.define('sen-product-ui',class extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('product-info');
        this.labels = JSON.parse(this.querySelector('[data-sen-ui-labels]').textContent);
        this.dialog = this.querySelector('dialog');
        this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); });
        this.prepare = this.prepare.bind(this);
        this.schedule = () => { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(this.prepare); };
        this.observer = new MutationObserver(this.schedule);
        this.observer.observe(this.root,{childList:true,subtree:true});
        this.resizeObserver = new ResizeObserver(this.schedule);
        this.resizeObserver.observe(this.root.querySelector('.product__info-container'));
        this.root.addEventListener('click', this.onGalleryClick = (event) => {
          const button = event.target.closest('.sen-thumbnail-more');
          if (!button) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          const target = button.closest('[data-target]')?.dataset.target;
          this.root.querySelector(`[data-media-id="${CSS.escape(target || '')}"] modal-opener button`)?.click();
        },true);
        this.prepare();
        write(recentKey,[this.dataset.handle,...read(recentKey).filter(handle=>handle!==this.dataset.handle)].slice(0,8));
        sync();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.frame);
        this.root?.removeEventListener('click',this.onGalleryClick,true);
      }
      prepare() {
        const thumbs = [...this.root.querySelectorAll('.thumbnail-list__item')];
        const more = thumbs.length > 5 ? thumbs[4].querySelector('button') : null;
        this.root.querySelectorAll('.sen-thumbnail-more').forEach(button => {
          if (button !== more) { button.classList.remove('sen-thumbnail-more'); button.querySelector('.sen-thumbnail-more__count')?.remove(); }
        });
        if (more && !more.classList.contains('sen-thumbnail-more')) {
          more.classList.add('sen-thumbnail-more');
          const count = document.createElement('span');
          count.className = 'sen-thumbnail-more__count';
          count.textContent = `+${thumbs.length - 5}`;
          count.setAttribute('aria-hidden','true');
          more.append(count);
          more.setAttribute('aria-label',this.labels.more_media);
        }
        this.root.toggleAttribute('data-sen-gallery-ready',!!more);
        const source = this.root.querySelector('.sen-size-guide-source');
        const info = this.root.querySelector('.product__info-container');
        const anchor = this.root.querySelector('[data-sen-size-label]');
        const trigger = source?.querySelector('[role="button"],button');
        this.root.toggleAttribute('data-sen-size-guide-ready',!!trigger);
        if (trigger && anchor) {
          const infoRect = info.getBoundingClientRect();
          const anchorRect = anchor.getBoundingClientRect();
          source.style.position = 'absolute';
          source.style.top = `${anchorRect.top - infoRect.top - 3}px`;
          source.style.left = `${anchorRect.right - infoRect.left + 10}px`;
          source.style.width = 'max-content';
        }
      }
      async showWishlist(message = '') {
        if (!this.dialog.open) this.dialog.showModal();
        const status = this.querySelector('[data-sen-wishlist-status]');
        const target = this.querySelector('[data-sen-wishlist-items]');
        status.textContent = message || (saved.length ? this.labels.loading : this.labels.empty);
        const handles = [...saved];
        const cards = await Promise.all(handles.map(getTile));
        if (handles.join() !== saved.join()) return;
        target.replaceChildren();
        cards.forEach((card,index) => {
          if (!card) return;
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'sen-wishlist-remove';
          remove.dataset.senWishlistRemove = handles[index];
          remove.textContent = this.labels.remove;
          card.append(remove);
          target.append(card);
        });
        status.textContent = !saved.length ? this.labels.empty : !target.children.length ? this.labels.error : message;
        sync();
      }
      feedback(message) {
        const node = this.querySelector('[data-sen-feedback]');
        node.textContent = message;
        node.hidden = false;
        clearTimeout(this.feedbackTimer);
        this.feedbackTimer = setTimeout(()=>node.hidden=true,4000);
      }
    });
    document.addEventListener('click',async event => {
      const ui = document.querySelector('sen-product-ui');
      if (!ui) return;
      const toggle = event.target.closest('[data-sen-wishlist]');
      const remove = event.target.closest('[data-sen-wishlist-remove]');
      if (toggle || remove) {
        event.preventDefault();
        const handle = toggle?.dataset.senWishlist || remove.dataset.senWishlistRemove;
        if (!validHandle(handle)) return;
        const existed = saved.includes(handle);
        saved = existed || remove ? saved.filter(item=>item!==handle) : [handle,...saved].slice(0,50);
        write(wishlistKey,saved);
        sync();
        ui.showWishlist(existed || remove ? ui.labels.removed : ui.labels.saved);
      }
      if (event.target.closest('[data-sen-wishlist-open]')) ui.showWishlist();
      if (event.target.closest('[data-sen-close-wishlist]')) ui.dialog.close();
      if (event.target.closest('[data-sen-size-guide-open]')) ui.root.querySelector('.sen-size-guide-source [role="button"],.sen-size-guide-source button')?.click();
      if (event.target.closest('[data-sen-share]')) {
        const url = new URL(location.href);
        url.searchParams.delete('preview_theme_id');
        try {
          if (navigator.share) await navigator.share({title:ui.dataset.title,url:url.href});
          else { await navigator.clipboard.writeText(url.href); ui.feedback(ui.labels.copied); }
        } catch (error) { if (error.name !== 'AbortError') ui.feedback(url.href); }
      }
    });
    window.addEventListener('storage',event => { if (event.key === wishlistKey) { saved = read(wishlistKey); sync(); } });
  })();
  } catch(e) { console.error(e); }
})();

})();
